import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {Button} from 'react-bootstrap';
import axios from 'axios';
import ContractDeliverableDeliveredModal from "./ContractDeliverableDeliveredModal";

export default class ContractDeliverableDelivered extends Component {
    constructor() {
        super();

        this.state = {
            deliverable_id: 0,
            deliverables: [],
            show_modal: false
        };

        this.closeModal = this.closeModal.bind(this);
        this.viewDetails = this.viewDetails.bind(this);
    }

    componentWillMount() {
        this.getDeliverables();
    }

    getDeliverables() {
        const url = this.props.is_supplier
            ? `/my_contracts/${this.props.contractId}/deliverables/deliveries`
            : `/contracts/ajax/manage_contracts/${this.props.contractId}/deliverables_delivered`;

        axios
            .get(url)
            .then((response) => {
                this.setState({
                    deliverables: response.data
                });
            });
    }

    closeModal() {
        this.setState({show_modal: false}, () => {
            this.getDeliverables();
        });
    }

    viewDetails(id) {
        this.setState({
            show_modal: true,
            deliverable_id: id
        });
    }

    render() {
        let rows = [];
        let items = this.state.deliverables;

        if (items.length > 0) {
            for (let key in items) {
                let item = items[key];

                if (items.hasOwnProperty(key)) {
                    rows.push(
                        <div className="like-row" key={item.id}>
                            <div className="title like-cell">
                                <div className="cell-label">{window.__js_contracts.deliverable_name}</div>
                                <div className="cell-value">{item.title}</div>
                            </div>

                            <div className="deadline like-cell">
                                <div className="cell-label">{window.__js_contracts.deliverable_date}</div>
                                <div className="cell-value">{item.deadline_formatted}</div>
                            </div>

                            <div className="is-delivered like-cell">
                                <div className="cell-label">{window.__js_contracts.is_delivered}</div>
                                <div className="cell-value">{item.is_delivered_literal}</div>
                            </div>

                            <div className="delivered-at like-cell">
                                <div className="cell-label">{window.__js_contracts.received_date}</div>
                                <div className="cell-value">{item.delivered_at_formatted}</div>
                            </div>

                            <div className={"actions like-cell" + (this.props.readonly ? " hidden" : "")}>
                                <div className="cell-label"></div>
                                <div className="cell-value">
                                    <Button onClick={() => this.viewDetails(item.id)}
                                            bsStyle="primary"
                                            bsSize="xsmall">
                                        <i className="fa fa-info-circle"></i> {window.__js_contracts.details}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    );
                }
            }
        } else {
            rows.push(
                <div key="0" className="fullwidth-new like-cell">
                    <em>{window.__js_contracts.no_entries}</em>
                </div>
            );
        }

        let modal = null;
        if (!this.props.readonly) {
            modal = (
                <ContractDeliverableDeliveredModal
                    id={this.state.deliverable_id}
                    contractId={this.props.contractId}
                    showModal={this.state.show_modal}
                    closeCallback={this.closeModal}/>
            );
        }

        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <div id="contract-deliverable-delivered-container">
                            <div id="contract-deliverable-delivered-head" className="like-row like-thead">
                                <div className="title like-cell">{window.__js_contracts.deliverable_name}</div>
                                <div className="deadline like-cell">{window.__js_contracts.deliverable_date}</div>
                                <div className="is-delivered like-cell">{window.__js_contracts.is_delivered}</div>
                                <div className="delivered-at like-cell">{window.__js_contracts.received_date}</div>
                                <div
                                    className={"actions like-cell" + (this.props.readonly ? " hidden" : "")}>{window.__js_contracts.actions}
                                </div>
                            </div>
                            <div className="like-tbody">
                                {rows}
                            </div>
                        </div>
                    </div>
                </div>
                {modal}
            </div>
        );
    }
}

if (document.getElementById("contract-deliverable-delivered")) {
    let element = document.getElementById("contract-deliverable-delivered");
    let csrf_token = element.getAttribute("data-csrf-token");
    let contract_id = element.getAttribute("data-contract-id");
    let readonly = (element.getAttribute("data-readonly") === "1");
    let is_supplier = (element.getAttribute("data-is-supplier") === "1");

    ReactDOM.render(
        <ContractDeliverableDelivered
            csrfToken={csrf_token}
            contractId={contract_id}
            readonly={readonly}
            is_supplier={is_supplier}/>,
        element
    );
}